export {AppRouting} from './app.routing';
